import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import 'react-phone-number-input/style.css'
import { useTranslation } from 'react-i18next';
import BackgroundImage from "../reusable-components/background-image";
import Header from "./header";
import Footer from "./footer";
import ActivationForm from "../views/Activation/activation-form";
import { useSearchParams } from "react-router-dom";
import ActivationSuccess from "../views/Activation/activation-success";
import ActivationFailure from "../views/Activation/activation-failure";
import FallbackError from "../views/Activation/fallback-error";
import useGetActivationInfo from "../hooks/Activation/getActivationInfo";
import { Screens } from "../constants/Activation/enum";
import { isEmpty } from "lodash";

const ActivationContainer = () =>
{
  const { t, i18n } = useTranslation();
  let [searchParams] = useSearchParams();
  const { productUrls, uiTheme } = useSelector((state) => state.activation);
  const [screen, setScreen] = useState("")
  const [loading, setLoading] = useState(true)
  const [queryParams, setQueryParams] = useState({})
  const [getActivationInfo] = useGetActivationInfo(setScreen, setLoading)

  /**
   * useEffect hook for retrieving query parameters from the url and sending it to the ActivationForm component
   */
  useEffect(() =>
  {
    const lng = navigator.language;
    i18n.changeLanguage(lng);
    let params = {
      activationToken: searchParams.get("activationToken"),
      activationId: searchParams.get("activationId"),
      productId: searchParams.get("productId")
    }
    setQueryParams(params)
    getActivationInfo(params)
  }, [])
  return (
    <>
      {loading ? <p className="margin-lt-16">{t('loading')}</p> :
        <div className="height-full">
          <BackgroundImage />
          <Header />
          <div
            className="sign-in-box ext-sign-in-box has-header fade-in-lightbox"
            style={{ overflow: 'visible' }}
          >
            {!isEmpty(productUrls.logo) && <img
              src={productUrls.logo}
              alt="Organization banner logo"
              className="banner-logo margin-tp-16"
            />}
            <div className="row title ext-title" style={{ color: uiTheme.buttonColour }}>
              {t('mainHeader')}
            </div>
            {screen === Screens.SUCCESS && <ActivationSuccess />}
            {screen === Screens.FORM && <ActivationForm queryParams={queryParams} setScreen={setScreen} />}
            {screen === Screens.ACTIVATION_FAILURE && <ActivationFailure />}
            {screen === Screens.FALLBACK_ERROR && <FallbackError />}
          </div>
          <Footer />
        </div>
      }
    </>
  );
};

export default ActivationContainer;
